
<div class="watermark" *ngIf="env.DEMO != ''">{{env.DEMO}}</div>
<div fxLayout="column" style="height: 100%;">
  <div class="demo-banner" *ngIf="env.DEMO != ''">
    <div class="scroll-text">
      ⚠️ {{env.DEMO}} - This environment is for demonstration purposes only. Data shown is not real and may be reset at any time.
    </div>
  </div>

  
  <mat-sidenav-container style="height: inherit;">
      <mat-sidenav class="sideNav" #sideNav [mode]="showContainer ? 'side' : 'over'" [opened]="openSideNav" (closed)="onCloseMenu()">
        <!-- <mat-nav-list>
          <app-side-nav-menu-item #sideNavItem *ngFor="let navBarItem of menuLists" 
            [navBarItem]="navBarItem" style="margin: 0; padding: 0;">
          </app-side-nav-menu-item>
        </mat-nav-list> -->
        <app-navigation-menu (onRouted)="onCloseMenu()"></app-navigation-menu>
      </mat-sidenav>
  
      <mat-sidenav-content fxLayout="column">
        
          <div class="v3-menubar ps-2 pe-3 py-3 flex flex-row justify-content-between">
            <div class="flex align-items-center">
              <img class="cursor-pointer menu-toggle" [class.flipped]="!openSideNav" (click)="toggleSideNav()" src="/assets/v3/icon/toggle-menu-icon.svg" />
            </div>
            <div class="flex align-items-center column-gap-2">
                <app-notifications></app-notifications>
                <app-user-profile></app-user-profile>
            </div>
          </div>
          <div class="sideNavContent" fxLayout="column">
            <!-- <div class='pageTittle d-flex align-items-center'>
              <ng-container *ngIf="displayBackButton">
                <i class="pi pi-arrow-left me-3 cursor-pointer" style="z-index: 1000; font-size: 24px; font-weight: bolder;" (click)="navService.NavigateParentRoute()"></i>
              </ng-container>
              {{ title }}    
              <div *ngIf="pstatus != null" class="status-chip-container">
                <p-chip *ngIf="pstatus == 'Draft'" class="pchip  d-flex ms-2" styleClass="s-draft" label="{{ pstatus }}"></p-chip>
                <p-chip *ngIf="pstatus == 'Pending'" class="pchip  d-flex ms-2" styleClass="s-pending" label="{{ pstatus }}"></p-chip>
                <p-chip *ngIf="pstatus == 'Pending Approval'" class="pchip  d-flex ms-2" styleClass="s-pending" label="{{ pstatus }}"></p-chip>
                <p-chip *ngIf="pstatus == 'Counting'" class="pchip  d-flex ms-2" styleClass="s-pending" label="{{ pstatus }}"></p-chip>
                <p-chip *ngIf="pstatus == 'Adjustment'" class="pchip  d-flex ms-2" styleClass="s-adjustment" label="{{ pstatus }}"></p-chip>
                <p-chip *ngIf="pstatus == 'Processed'" class="pchip  d-flex ms-2" styleClass="s-processed" label="{{ pstatus }}"></p-chip>
                <p-chip *ngIf="pstatus == 'Approved'" class="pchip  d-flex ms-2" styleClass="s-approved" label="{{ pstatus }}"></p-chip>
                <p-chip *ngIf="pstatus == 'Completed'" class="pchip  d-flex ms-2" styleClass="s-processed" label="{{ pstatus }}"></p-chip>
                <p-chip *ngIf="pstatus == 'Rejected'" class="pchip  d-flex ms-2" styleClass="s-rejected" label="{{ pstatus }}"></p-chip>
              </div> 
              
            </div> -->
            <div >
              <router-outlet></router-outlet>
            </div>
            <div class="footer-container">
              <div class="footer-content">
                <span>Copyright &copy; {{ currentYear }} </span>
                <span>Powered by Qube Apps Solutions Sdn Bhd (981542-A) | {{env.version}}</span>
              </div>
            </div>
          </div>

          <p-scrollTop [threshold]="50" target="parent" styleClass="fixed" icon="pi pi-chevron-up"> </p-scrollTop> 
      </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<p-sidebar [(visible)]="notificationDrawer" [blockScroll]="true" position="right" appendTo="body" [showCloseIcon]="false" styleClass="p-sidebar-md">
  <div class="flex flex-column row-gap-2">
    <div class="flex align-items-center justify-content-between mb-2 notification-header">
      <span class="font-medium">Notifications</span>
      <i class="pi pi-times cursor-pointer" (click)="notificationDrawer = false"></i>
    </div>
    <div class="flex flex-column row-gap-1" *ngIf="notificationDataToday.length > 0">
      <span class="text-sm font-medium">Today</span>
      <div *ngFor="let today of notificationDataToday" (click)="redirectNotification(today)" class="px-1 py-2 flex flex-row align-items-center justify-content-between text-xs cursor-pointer notification-item">
        <div class="flex flex-row align-items-center column-gap-2">
          <img src="/assets/v3/icon/Unread.svg" />
          <span class="flex flex-wrap">{{ today?.message }}</span>
        </div>
        <span class="text-end">{{today?.timestamp | notificationDate}}</span>
      </div>
    </div>
    <div class="flex flex-column row-gap-1" *ngIf="notificationDataEarlier.length > 0">
      <span class="text-sm font-medium">Earlier</span>
      <div *ngFor="let earlier of notificationDataEarlier" (click)="redirectNotification(earlier)" class="px-1 py-2 flex flex-row align-items-center justify-content-between text-xs cursor-pointer notification-item">
        <div class="flex flex-row align-items-center column-gap-2">
          <img src="/assets/v3/icon/Unread.svg" />
          <span class="flex flex-wrap">{{ earlier?.message }}</span>
        </div>
        <span class="text-end">{{earlier?.timestamp | notificationDate}}</span>
      </div>
    </div>
    <div *ngIf="notificationDataToday.length < 1 && notificationDataEarlier.length < 1" class="flex flex-column align-items-center justify-content-center">
      No notifications...
    </div>
  </div>
</p-sidebar>